<div class="container">
  <form [formGroup]="personalInfo">
    <div class="double-field-container">
      <mat-form-field appearance="outline" class="names-container-item">
        <mat-label>
          Imię
        </mat-label>
        <input matInput formControlName="name" id="name" required/>
        <mat-error *ngIf="personalInfo.get('name').hasError('required')">
          Imię jest wymagane
        </mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline" class="names-container-item">
        <mat-label>
          Drugie imię
        </mat-label>
        <input matInput formControlName="secondName" id="secondName"/>
      </mat-form-field>
    </div>
    <div class="double-field-container">
      <mat-form-field appearance="outline">
        <mat-label>
          Nazwisko
        </mat-label>
        <input matInput formControlName="surname" id="surname" required/>
        <mat-error *ngIf="personalInfo.get('surname').hasError('required')">
          Nazwisko jest wymagane
        </mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>
          PESEL
        </mat-label>
        <input matInput formControlName="pesel" id="pesel"/>
        <mat-error
          *ngIf="
                personalInfo.get('pesel').hasError('pattern') ||
                personalInfo.get('pesel').hasError('minlength') ||
                personalInfo.get('pesel').hasError('maxlength')">
          Podaj poprawny numer PESEL
        </mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>
          Zewnętrzne ID
        </mat-label>
        <input matInput formControlName="individualNumber" id="individualNumber"/>
      </mat-form-field>
    </div>
    <app-new-address label="Adres siedziby"
                     formControlName="mainAddress"
                     [fixedAddressType]="AddressType.MAIN" [required]="true"></app-new-address>
    <app-new-address label="Adres korespondencyjny"
                      formControlName="correspondenceAddress"
                     [fixedAddressType]="AddressType.CORRESPONDENCE"></app-new-address>
  </form>
</div>
